export function isMobile(): boolean {
  return !!navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i);
}

export function isIos(): boolean {
  return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
}

export function isAndroid(): boolean {
  return !!navigator.userAgent.match(/Android/i);
}

export function isClipboardSupported(): boolean {
  return !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
}

/**
 * Schreibt einen Wert in die Zwischenablage.
 * @returns `true` bei Erfolg, `false` bei Misserfolg
 */
export async function writeToClipboard(
  value: string,
  problemReporter: (message: string) => void = console.error
): Promise<boolean> {
  if (!isClipboardSupported()) {
    if (!globalThis.isSecureContext) {
      problemReporter('Zwischenablage nicht verfügbar: Die Anwendung muss über HTTPS ausgeführt werden.');
    } else {
      problemReporter('Zwischenablage wird von diesem Browser nicht unterstützt.');
    }
    return false;
  }

  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch (error) {
    problemReporter(`Der Wert konnte nicht in die Zwischenablage kopiert werden: ${String(error)}`);
    return false;
  }
}
